import script from "./AutoPayDisabled.vue?vue&type=script&lang=ts&setup=true"
export * from "./AutoPayDisabled.vue?vue&type=script&lang=ts&setup=true"

import "./AutoPayDisabled.vue?vue&type=style&index=0&id=2d0b3cb9&lang=scss"

const __exports__ = script;

export default __exports__